import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getManualDownloadHistoricalFile,
  getManualDownloadTemplate,
  getManualGenerateS3URL,
  getManualTable,
} from "../api/manualFileUpload";

export const fetchManualDownloadTemplate = createAsyncThunk(
  "manualFileUpload/fetchManualDownloadTemplate",
  async (params) =>
    getManualDownloadTemplate(params?.kpiName, params?.month, params?.year)
);

export const fetchManualGenerateS3URL = createAsyncThunk(
  "manualFileUpload/fetchManualGenerateS3URL",
  async (params) => getManualGenerateS3URL(params?.kpiName, params?.fileName)
);

export const fetchManualTable = createAsyncThunk(
  "manualFileUpload/fetchManualTable",
  async (params) =>
    getManualTable(
      params?.kpiName,
      params?.page,
      params?.limit,
      params?.month,
      params?.year
    )
);

export const fetchManualDownloadHisoricalFile = createAsyncThunk(
  "manualFileUpload/fetchManualDownloadHisoricalFile",
  async (params) => getManualDownloadHistoricalFile(params?.filePath)
);

export const manualFileUploadSlice = createSlice({
  name: "manualFileUpload",
  initialState: {
    downloadedTemplate: null,
    s3URLDetails: null,
    tableDetails: null,
    downloadHistoricalFile: null,
    loading: false,
  },
  extraReducers: {
    [fetchManualDownloadTemplate.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchManualDownloadTemplate.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.downloadedTemplate = payload;
    },
    [fetchManualDownloadTemplate.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchManualGenerateS3URL.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchManualGenerateS3URL.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.s3URL = payload;
    },
    [fetchManualGenerateS3URL.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchManualTable.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchManualTable.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.tableDetails = payload;
    },
    [fetchManualTable.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchManualDownloadHisoricalFile.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchManualDownloadHisoricalFile.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.downloadHistoricalFile = payload;
    },
    [fetchManualDownloadHisoricalFile.rejected]: (state, { payload }) => {
      state.loading = false;
    },
  },
});

export default manualFileUploadSlice.reducer;
